class GolfProofStats extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.timers = [];
    this.effects = [];
    this.numbers = [...this.querySelectorAll('[data-proof-count]')].map(slot => ({
      slot, target: Number(slot.dataset.proofCount), text: slot.textContent
    }));
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) this.finish();
    }, { signal: this.controller.signal });
    this.prepare(this.controller.signal);
  }

  async prepare(signal) {
    if (this.motion.matches || !('IntersectionObserver' in window)) return this.finish();
    try {
      const [{ default: NumberFlow, canAnimate, continuous }] = await Promise.all([
        import(this.dataset.numberFlow), document.fonts.ready
      ]);
      if (signal.aborted) return;
      if (!canAnimate || this.motion.matches) return this.finish();
      this.numbers.forEach(number => {
        const reserve = document.createElement('span');
        reserve.className = 'gk-stat__reserve';
        reserve.textContent = number.text;
        const flow = new NumberFlow();
        flow.locales = 'sv-SE';
        flow.format = { useGrouping: true, maximumFractionDigits: 0 };
        flow.plugins = [continuous];
        flow.transformTiming = { duration: 1000, easing: 'cubic-bezier(.22,1,.36,1)' };
        flow.spinTiming = flow.transformTiming;
        flow.opacityTiming = { duration: 220, easing: 'ease-out' };
        flow.animated = false;
        number.slot.replaceChildren(reserve, flow);
        flow.update(0);
        flow.animated = true;
        number.flow = flow;
      });
      this.dataset.state = 'ready';
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .4)) this.play();
      }, { threshold: .4 });
      this.observer.observe(this);
    } catch { if (!signal.aborted) this.finish(); }
  }

  play() {
    if (this.played) return;
    this.played = true;
    this.observer?.disconnect();
    if (this.motion.matches) return this.finish();
    this.dataset.state = 'playing';
    this.numbers.forEach((number, index) => {
      this.timers.push(setTimeout(() => {
        if (this.controller.signal.aborted) return;
        number.flow.update(number.target);
        const article = number.slot.closest('article');
        this.effects.push(article.animate([
          { opacity: .65, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' }));
      }, index * 80));
    });
    this.timers.push(setTimeout(() => { this.dataset.state = 'complete'; }, 1320));
  }

  finish() {
    this.played = true;
    this.observer?.disconnect();
    this.timers.forEach(clearTimeout);
    this.effects.forEach(effect => effect.cancel());
    this.numbers.forEach(number => {
      if (number.flow) {
        number.flow.animated = false;
        number.flow.update(number.target);
      } else number.slot.textContent = number.text;
    });
    this.dataset.state = 'static';
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.finish();
    this.controller = null;
  }
}

if (!customElements.get('gk-proof-stats')) customElements.define('gk-proof-stats', GolfProofStats);
